
import { useContext, useLayoutEffect } from 'react'
import { AppMainContext } from '../context/AppMainContext';
import { useNavigate } from 'react-router-dom';

export default function SignIn() {
  const { currentUser, signinFlag, setSigninName, signinName, setSigninPass, signinPass, handleSignin, connected } = useContext(AppMainContext);
  const nav = useNavigate();
  useLayoutEffect(()=>{
    if(connected){
      handleSignin(nav, currentUser.name, currentUser.pass);
    }
  },[])
  return (
    <div className="signForm_page">
        <div className="signForm_div">
            <h1 className="signForm_header">התחברות</h1>
            <div className="signForm_inputs">
                <input className="signForm_input" type='text' placeholder='שם משתמש' onChange={(e)=>{setSigninName(e.target.value)}}/>
                <input className="signForm_input" type='text' placeholder='סיסמא' onChange={(e)=>{setSigninPass(e.target.value)}}/>
            </div>
            <button className="signForm_btn" disabled={signinFlag} onClick={()=>{handleSignin(nav, signinName, signinPass)}}>{signinFlag ? "המתן..." : "תכניס אותי"}</button>
        </div>
        <div className="signForm_linkDiv">
            <p className="signForm_link_p">להרשמה לחץ <a className="signForm_link_a" href="/signup">כאן</a></p>
        </div>
    </div>
  )
}
